module.exports = __webpack_public_path__ + "static/media/trophy.7e43c91b.png";